import { FiltroSelecionado } from "./filtro-selecionado.model";

export class FiltroSubmit {
    public query: string;
    public filtros: FiltroSelecionado[]
    public filtroDescricao: string;
}